import SearchUser from './SearchUser.component';

export default SearchUser;
